import * as React from 'react';

import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';
import { Context } from 'bernie-context';
import { Header as HeaderBernie } from 'bernie-global-components';

import { MyList } from 'components/common/header/my-list';
import { Qualtrics } from 'components/common/header/qualtrics';

export interface HeaderProps {
  context?: Context;
  className?: string;
}

export class Header extends React.Component<HeaderProps> {
  public render() {
    return (
      <HeaderBernie className={this.props.className}>
        <MyList />
        {/* the Qualtrics experiments below are for different POSes and will not have more than one bucketed in */}
        <AbacusExperiment name="PWA_Qualtrics_Intercept">
          <AbacusControl />
          <AbacusVariant bucket={1}>
            <Qualtrics />
          </AbacusVariant>
        </AbacusExperiment>
        <AbacusExperiment name="PWA_Qualtrics_Intercept_for_BEX_Rest_of_World">
          <AbacusControl />
          <AbacusVariant bucket={1}>
            <Qualtrics />
          </AbacusVariant>
        </AbacusExperiment>
        <AbacusExperiment name="PWA_Qualtrics_Intercept_for_Comet">
          <AbacusControl />
          <AbacusVariant bucket={1}>
            <Qualtrics />
          </AbacusVariant>
        </AbacusExperiment>
      </HeaderBernie>
    );
  }
}

HeaderBernie.displayName = 'HeaderBernie';
